import { fetchTeamConfigs } from 'TeamModule/services';
import { useAppQuery } from 'core/query/hooks/useAppQuery';
import { teamQueryKeys } from '../teamQueryKeys';
import { FetchTeamConfigsSuccessResponse } from 'TeamModule/types';

export const useTeamConfigsQuery = (params: { teamId: number }) => {
  const { teamId } = params;

  const query = useAppQuery({
    queryKey: teamQueryKeys.detail({
      ...params,
      identifier: `useTeamConfigsQuery`,
    }),
    queryFn: async ({ token, buildConfig }) => {
      // buildConfig() automatically includes URL context headers (tenant/realmId)
      const response = await fetchTeamConfigs({
        params: { mosaicTeamId: teamId },
        token,
        config: buildConfig(),
      });
      return response?.data as FetchTeamConfigsSuccessResponse | undefined;
    },
  });

  return query;
};
